import React from 'react'
import { withRouter } from 'react-router-dom'
import { Card } from '@myxplor/ui'

import GetOffboardingStatus from '../offboarding/forms/getOffboardingStatus'
import PostOffboardingStatus from '../offboarding/forms/postOffboadingStatus'

class OffboardingSubmissions extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      serviceId: null,
      regHolder: null,
      submissionBlocked: null,
      notes: null,
      newStatus: null
    }
    this.updateServiceId = this.updateServiceId.bind(this)
    this.updateOffboardingStatus = this.updateOffboardingStatus.bind(this)
    this.updateNewOffboardingStatus = this.updateNewOffboardingStatus.bind(this)
  }

  updateServiceId(serviceId) {
    this.setState(function(prevState) {
      return {
        ...prevState,
        serviceId: serviceId
      }})
  }

  updateOffboardingStatus(data) {
    this.setState(function(prevState){
      return {
        ...prevState,
        regHolder: data.reg_holder,
        submissionBlocked: data.blocked,
        notes: data.notes
      }})
  }

  updateNewOffboardingStatus(data) {
    this.setState(function(prevState){
      return {
        ...prevState,
        newStatus: data
      }
    })
  }


  render() {
    const { serviceId, regHolder, submissionBlocked, notes, newStatus } = this.state

    if(newStatus){
      const { blocked, notes } = newStatus
      
      return(
        <Card>
          <h2>Offboarding Status Updated</h2>

          <h2>{regHolder.name}</h2>
          <p><strong>Submissions:</strong> {blocked ? 'blocked' : 'unblocked'}</p>
          <p><strong>Notes:</strong></p>
          <p>{notes ? notes : 'No notes recorded'}</p>
        </Card>
      )
    }

    if(regHolder){
      return(
        <Card>
          <PostOffboardingStatus
            submissionBlocked = {submissionBlocked}
            regHolder = {regHolder}
            serviceId = {serviceId}
            notes = {notes}
            updateNewOffboardingStatus = {this.updateNewOffboardingStatus}
          />
        </Card>
      )
    }

    return(
      <Card>
        <h2>Check Offboarding Status</h2>
        <GetOffboardingStatus
          updateServiceId = {this.updateServiceId}
          updateOffboardingStatus = {this.updateOffboardingStatus}  
        />
      </Card>
    )
  }
}

export default withRouter(OffboardingSubmissions)


// WEBPACK FOOTER //
// ./src/offboarding/container.js